module.exports = __webpack_public_path__ + "static/TTNormsPro-Italic-dc3a277ba27ab965c6ec427361142a2e.woff";